import { render, staticRenderFns } from "./template.vue?vue&type=template&id=63fc3091&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"
import style0 from "./template.vue?vue&type=style&index=0&id=63fc3091&prod&lang=scss&scoped=true"
import style1 from "./template.vue?vue&type=style&index=1&id=63fc3091&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc3091",
  null
  
)

export default component.exports